import keycloak from "../keycloak";
import { envConfig } from "../config/env";

export const keycloakLoginURL = "/register";

let refreshPromise = null;

export const getToken = () => {
  if (!keycloak.authenticated || !keycloak.token) {
    return null;
  }
  return `Bearer ${keycloak.token}`;
};

export const refreshToken = async () => {
  if (!keycloak.authenticated) return false;

  if (!refreshPromise) {
    refreshPromise = keycloak.updateToken(60).then((refreshed) => {
      if (refreshed) {
        localStorage.setItem("kc_token", keycloak.token);
        localStorage.setItem("kc_refresh_token", keycloak.refreshToken);
        if (keycloak.idToken) {
          localStorage.setItem("kc_id_token", keycloak.idToken);
        }
      }
      return true;
    }).finally(() => {
      refreshPromise = null;
    }).catch(() => {
      refreshPromise = null;
      return false;
    });
  }

  return refreshPromise;
};

export const getFreshToken = async () => {
  if (!keycloak.authenticated || !keycloak.token) {
    return null;
  }

  await refreshToken();
  return getToken();
};

export const baseURL = envConfig.apiBaseUrl;

export const getClientToken = getToken;
